<template>
<div>
  <v-container fluid>
  <v-row class="time_period_wrap align-center">
    <span class="time_period_title pl-3">Time Period</span>
    <v-col cols="12" lg="2">
      <v-select
          v-model="timePeriodSelected"
          item-value="id"
          :items="timePeriodItems"
          solo
          dense
          hide-details
      ></v-select>
    </v-col>
    <v-col cols="12" lg="2" v-if="timePeriodSelected === 'Custom'">
      <v-menu
          ref="rangeMenu"
          v-model="rangeMenu"
          :close-on-content-click="false"
          :return-value.sync="timePeriodRange"
          transition="scale-transition"
          offset-y
          max-width="320px"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="dateRangeText"
              persistent-hint
              readonly
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              hide-details
              dark
              single-line
              class="pt-0 mt-0"
              label="Range"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="timePeriodRange"
            no-title
            :close-on-content-click="false"
            range
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="updateRange">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" lg="2">
      <v-row align="center" class="nowrap">
        <v-text-field
            v-model="table.searchInReports"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="text-left pt-0 mt-0"
            @input="debounceSearch"
            dark
            single-line
            hide-details
        ></v-text-field>
      <v-menu offset-y :close-on-content-click="false" v-model="columnsMenu" content-class="bg-white">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
            <v-icon color="white">mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <v-list flat>
          <v-subheader>Columns</v-subheader>
          <v-list-item-group
              v-model="table.selectedFields"
              multiple
          >
            <template v-for="header in table.headers">
            <v-list-item v-if="['drill_down', drillDown.type].indexOf(header.value) < 0" :value="header.value">
              <template v-slot:default="{ active }">
                <v-list-item-action class="mr-2">
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{header.text}}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="columnsMenu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="updateFields">OK</v-btn>
      </v-menu>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
  <template>
    <v-data-table
        dense
        :headers="tableHeaders"
        :items="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].data : []"
        :server-items-length="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].count : 0"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :disable-sort="true"
        item-key="name"
        fixed-header
        :class="`elevation-1 fixed-height report-table items-size-${table.heightCounter}`"
        color="#7F98A5"
        @pagination="updateTablePagination"
    >
      <!--header-->
      <template v-for="header in tableHeaders" :slot="`header.${header.value}`" slot-scope="{ header }">
        <data-filter :key="`filter-${drillDown.key}-${header.sortKey || header.value}`"
                     v-if="header.filterable === undefined || header.filterable"
                     :type="table.calculated.indexOf(header.sortKey || header.value) > -1 ? 'range' : 'items'"
                     :min="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'min').value : 0"
                     :max="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'max').value : 0"
                     :items="filtersData[header.sortKey || header.value] || []"
                     :entity="header.sortKey || header.value"
                     :values="getValues(header.sortKey || header.value)"
                     @search="searchFilter"
                     @apply="applyFilter"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.sortKey || header.value)">
          <span class="header_title" style="text-transform: capitalize">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5"> {{ (header.sortKey || header.value) === table.orderBy ? table.sortColumnsAsc ? 'mdi-arrow-up' : 'mdi-arrow-down' : 'mdi-arrow-up-down'}} </v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!--/header-->
      <!--body-->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else>{{item[header.value]}}</template>
      </template>
      <template v-slot:item.drill_down="{item}">
        <template v-for="dDown in table.drillDowns">
          <v-tooltip bottom v-if="isShowDrillDown(dDown, item)" :key="dDown.type">
            <template v-slot:activator="{ on, attrs }">
              <span
                  @click="addTab({
                    type: dDown.type,
                    name: dDown.name,
                    entity: drillDown.type,
                    value: dDown.value,
                    tabName: item[drillDown.value],
                    id: item[drillDown.type]
                  })"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon size="16" class="drill_down_btn">{{dDown.icon}}</v-icon>
              </span>
            </template>
            <span>{{dDown.name}}</span>
          </v-tooltip>
        </template>
      </template>
      <template :slot="`item.${drillDown.type}`" slot-scope="{ item }">
        <template v-if="isEntityName(drillDown.value)">
          <a class="entity-link" @click="showCard(item)">{{item[drillDown.value]}}</a>
        </template>
        <template v-else>{{item[drillDown.value]}}</template>
      </template>
      <template v-slot:item.avg_cost="{item}">
          ${{item.avg_cost}}
      </template>
      <template v-slot:item.cost="{item}">
          ${{item.cost}}
      </template>
      <template v-slot:item.revenue="{item}">
          ${{item.revenue}}
      </template>
      <template v-slot:item.profit="{item}">
          ${{item.profit}}
      </template>
      <template v-slot:item.margin="{item}">
          {{item.margin}}%
      </template>
      <!--/body-->
    </v-data-table>
    <span class="updateData">
      Last updated: {{ value }} mins ago
      <v-btn icon @click="updateData"><v-icon color="#7F98A5">mdi-autorenew</v-icon></v-btn>
    </span>
    <div style="margin-top: -60px" class="flex right">
      <v-menu v-if="table.filters.length" offset-y top :close-on-content-click="false" v-model="filtersMenu" content-class="bg-white">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
            <v-icon color="secondary">mdi-filter-remove{{filtersMenu ? '' : '-outline'}}</v-icon>
          </v-btn>
        </template>
        <template>
          <v-card>
            <v-card-subtitle>Are you sure you want clear all filters?</v-card-subtitle>
            <v-card-actions>
              <v-btn text color="secondary" @click="filtersMenu = false">NO</v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="removeAllFilters">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-menu>
      <v-btn icon :disabled="table.heightCounter >= 63" @click="table.heightCounter += 3">
        <v-icon size="24" color="#7F98A5">mdi-magnify-plus-outline</v-icon>
      </v-btn>
      <v-btn icon :disabled="table.heightCounter <= 33" @click="table.heightCounter -= 3">
        <v-icon size="24"  color="#7F98A5">mdi-magnify-minus-outline</v-icon>
      </v-btn>
    </div>
  </template>
</div>
</template>

<script>
import { mapGetters } from "vuex"
import {getCookie, updateDate} from "@/helpers"
import { debounce } from 'debounce'
import DataFilter from "@/components/common/DataFilter";
import store from "../../store";

export default {
  props: {
    drillDown : Object,
    timePeriodType : String,
    timePeriod : Object,
    additionalColumns : Array,
  },
  components: {
    DataFilter
  },
  data: vm=>({
    table: {
      loading: false,
      searchInReports: '',
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 500],
      orderBy: 'clicks',
      sortColumnsAsc: false,
      heightCounter: 42,
      headers: [
        { text: 'Drill down', value: 'drill_down', align: 'center', sortable: false, filterable: false },
        { text: 'Tags', value: 'tags', align: 'left', sortable: false },
        { text: 'Main', value: 'main', align: 'center'},
        { text: 'Clicks', value: 'clicks', align: 'center' },
        { text: 'Conversions', value: 'conversions', align: 'center' },
        { text: 'EPC', value: 'epc', align: 'center' },
        { text: 'Avg. Cost', value: 'avg_cost', align: 'center' },
        { text: 'Cost', value: 'cost', align: 'center' },
        { text: 'Revenue', value: 'revenue', align: 'center' },
        { text: 'Margin', value: 'margin', align: 'center' },
        { text: 'Profit', value: 'profit', align: 'center' },
      ],
      selectedFields: [],
      calculated: [
         'clicks', 'conversions', 'epc', 'avg_cost', 'cost', 'revenue', 'margin', 'profit'
      ],
      drillDowns: [
        {type: 'offer_id', value: 'offer', name: 'Offer', icon: 'mdi-offer'},
        {type: 'campaign_id', value: 'campaign', name: 'Campaign', icon: 'mdi-bullhorn-outline'},
        {type: 'geo', value: 'geo', name: 'Geo', icon: 'mdi-earth'},
        {type: 'day', value: 'day', name: 'Day', icon: 'mdi-calendar-today'},
        {type: 'hour', value: 'hour', name: 'Hour', icon: 'mdi-hours-24'},
        {type: 'isp', value: 'isp', name: 'ISP', icon: 'mdi-spider-web'},
        {type: 'affiliate_id', value: 'affiliate', name: 'Affiliate', icon: 'mdi-account'},
        {type: 'os', value: 'os', name: 'Os', icon: 'mdi-microsoft-windows-classic'},
        {type: 'device', value: 'device', name: 'Device', icon: 'mdi-cellphone-link'},
      ],
      filters: [],
      lastSelectedFilter: ''
    },
    rangeMenu: false,
    timePeriodSelected: 'Today',
    timePeriodItems: ['Today', 'Yesterday', 'Week to date', 'Month to date', 'Year to day', 'Last week', 'Last month', 'Custom'],
    timePeriodRange: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
    interval: {},
    value: 0,
    filtersData: {},
    columnsMenu: false,
    filtersMenu: false
  }),

  beforeDestroy () {
    clearInterval(this.interval)
  },

  async mounted () {
    if (this.timePeriodType) {
      this.timePeriodSelected = this.timePeriodType;
    }
    if (this.timePeriod && this.timePeriod.from && this.timePeriod.to) {
      this.timePeriodRange = [this.timePeriod.from, this.timePeriod.to]
    }
    // todo replace this to dynamic fields feature
    const mainIndex = this.table.headers.findIndex(f => f.value === 'main');
    this.table.headers.splice(mainIndex, 1, {text: this.drillDown.name, value: this.drillDown.type, align: 'left'})
    if(this.additionalColumns) {
      for(let i = 0; i < this.additionalColumns.length; i++) {
        this.table.headers.splice(3+i, 0, this.additionalColumns[i]);
      }
    }
    const fields = JSON.parse(localStorage.getItem(`fields-${this.drillDown.key}`));
    this.table.selectedFields = fields ? fields : this.table.headers.map(h => h.value);
    this.updateFiltersFromQuery();
    await this.getGeneralData();
    this.interval = setInterval(() => {
      this.value += 3
    }, 180000)
  },

  watch: {
    timePeriodSelected () {
      this.getGeneralData()
    },
  },

  methods: {
    isEntityName(item) {
      console.log('card Reports', item)
      return ['advertiser', 'advertiser_id', 'affiliate'].includes(item)
    },
    showCard(item) {
      if(item['advertiser'] || item['advertiser_id']) {
        store.dispatch('cards/ADD', {
          type: 'advertiser',
          title: item.advertiser,
          key: `advertiser-${item.advertiser_id}`,
          data: item
        })
      } else if(item['affiliate']) {

        store.dispatch('cards/ADD', {
          type: 'affiliate',
          title: item.affiliate,
          key: `affiliate-${item.affiliate_id}`,
          data: item
        })
      }
    },
    debounceSearch: debounce(function (value) {
      this.table.searchInReports = value;
      this.getGeneralData();
    }, 700),
    async getGeneralData (filter = []) {
      this.table.loading = true
      filter.push(...this.table.filters);
      if (this.table.searchInReports.length > 0) {
        filter.push({
          field: 'search',
          value: [this.table.searchInReports],
        })
      }
      filter.push(...this.drillDown.breadCrumbs);
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      console.log(datePeriod);
      const additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;
      const select = [...this.table.selectedFields];
      select.splice(select.indexOf('drill_down'), 1);
      if(this.additionalColumns) {
        for (let i = 0; i < select.length; i++) {
          const aColumn = this.additionalColumns.find(c => c.value === select[i]);
          if (aColumn) {
            select.push(aColumn.sortKey);
          }
        }
      }

      await this.$store.dispatch('reports/saveDrillDownReports', {
        filter: filter,
        entity: this.drillDown.value,
        groupBy: additionalKeys ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type,
        select: select,
        fromDate: datePeriod.fromDate,
        toDate: datePeriod.toDate,
        limit: this.table.perPage,
        page: this.table.currentPage,
        orderBy: this.table.orderBy || '',
        orderDirectionAsc: this.table.sortColumnsAsc,
        drillDownType: this.drillDown.value,
        id: this.drillDown.id
      })
      this.getFiltersData();
      const options = {};
      options.periodType = this.timePeriodSelected;
      if (options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
      }
      if (!options.fromDate && !options.fromDate) {
        this.rangeMenu = true;
      }
      this.$emit('updateTab', this.drillDown.key, options);
      this.table.loading = false
    },
    async getFiltersData() {
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      const additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;
      this.table.headers.forEach(header => {
        if(header.filterable === undefined || header.filterable) {
          let filters = [...this.table.filters];
          if((header.sortKey || header.value) === this.table.lastSelectedFilter) {
            filters = filters.filter(f => f.field !== this.table.lastSelectedFilter);
          }
          // reportsApi.getFilter({
          //   filter: filters,
          //   name: header.sortKey || header.value,
          //   groupBy: additionalKeys ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type,
          //   fromDate: datePeriod.fromDate,
          //   toDate: datePeriod.toDate,
          // }).then(res => {
          //   this.filtersData = Object.assign({}, this.filtersData, res);
          // });
        }
      });
    },

    updateFiltersFromQuery() {
      const queryFilters = this.$route.query.filters && JSON.parse(this.$route.query.filters);
      if (queryFilters) {
        this.table.filters.push(queryFilters);
      }
    },

    getValues(entity) {
      const filter = this.table.filters.find(f => f.field === entity);
      return filter ? filter.value : undefined
    },
    camelToSnake(string) {
      return string.replace(/[\w]([A-Z])/g, function(m) {
        return m[0] + "_" + m[1];
      }).toLowerCase();
    },
    updateRange() {
      this.$refs.rangeMenu.save(this.timePeriodRange)
      this.getGeneralData()
    },
    updateFields() {
        localStorage.setItem(`fields-${this.drillDown.key}`, JSON.stringify(this.table.selectedFields));
        this.columnsMenu = false;
        this.getGeneralData();
    },
    updateTablePagination(params){
      if (
          this.table.currentPage === params.page &&
          this.table.perPage === params.itemsPerPage
      ) {
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      this.getGeneralData()
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = this.table.orderBy === column ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = this.camelToSnake(column)
      await this.getGeneralData()
    },
    updateDataInFilters(data, modalName) {

    },
    isShowDrillDown(drillDown, item) {
      if(this.drillDown.breadCrumbs.find(bc => bc.field === drillDown.type)) {
        return false;
      }
      return drillDown.type !== this.drillDown.type;
    },
    addTab(tab) {
      tab.breadCrumbs = [];
      this.drillDown.breadCrumbs.forEach(bc => {
        if(bc.field !== tab.entity && bc.value !== tab.id) {
          tab.breadCrumbs.push(bc)
        }
      })
      tab.key = this.drillDown.key || '';
      if (tab.id && tab.entity) {
        tab.breadCrumbs.push({field: tab.entity, value: tab.id, name: tab.tabName})
      }
      tab.key += `_${tab.id}_${tab.type}`;
      const options = {};
      options.periodType = this.timePeriodSelected;
      if(options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
      }
      this.$emit('goDown', tab, options)
    },
    updateData() {
      this.getGeneralData()
      this.value = 0
    },
    // new filter methods
    searchFilter(search, entity) {
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      reportsApi.getFilter({
        name: entity,
        groupBy: entity,
        fromDate: datePeriod.fromDate,
        toDate: datePeriod.toDate,
        searchFilter: search
      }).then(res => {
        this.filtersData = Object.assign({}, this.filtersData, res);
      });
    },
    async removeAllFilters() {
      this.table.filters = [];
      this.filtersMenu = false;
      await this.getGeneralData()
    },
    async applyFilter(data, entity) {
      const filterIndex = this.table.filters.findIndex(f => f.field === entity);
      if (filterIndex >= 0) {
        if (data && data.length) {
          this.table.filters.splice(filterIndex, 1, {field: entity, value: [...data]});
        } else {
          this.table.filters.splice(filterIndex, 1);
        }
        this.table.lastSelectedFilter = this.table.filters.length ? this.table.filters[this.table.filters.length - 1].field : '';
      } else {
        if (data && data.length) {
          this.table.lastSelectedFilter = entity;
          this.table.filters.push({field: entity, value: [...data]});
        } else {
          this.table.lastSelectedFilter = '';
        }
      }

      return await this.getGeneralData()
    },
  },
  computed: {
    dateRangeText () {
      return this.timePeriodRange.join(' - ')
    },
    tableHeaders() {
      console.log(this.table.selectedFields);
      return this.table.headers.filter(h => this.table.selectedFields.indexOf(h.value) > -1);
    },
    ...mapGetters('reports', ['getDrillDownReports', 'getMainFilterData']),
  }
}
</script>

<style lang="sass">

.report-table
  margin-top: 0px !important
  .v-data-table__wrapper
    height: 65.7vh
    overflow: auto
  .v-data-table-header
    th
      white-space: nowrap

.bg-white
  background-color: #fff
</style>
